export default __webpack_public_path__ + "static/media/PTT_LogoColor.6115276b.png";